module.exports = __webpack_public_path__ + "console/img/mad.a8d01c69.png";